exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.job-information-card--header-title[data-v-f12cb64e] {\n    flex: 0 0 50%;\n}\n", ""]);

// exports
